import { createRouter, createWebHistory } from 'vue-router';

// Ленивый импорт компонентов
const Home = () => import('@/pages/Home.vue');
const ProductList = () => import('@/pages/ProductList.vue');
const Profile = () => import('@/pages/Profile.vue');
const ProductPage = () => import('@/pages/ProductPage.vue');
const CoinBundlePage = () => import('@/pages/CoinBundlePage.vue');
const PaymentSuccessPage = () => import('@/pages/PaymentSuccessPage.vue');
const PaymentFaliPage = () => import('@/pages/PaymentFaliPage.vue');
const PaymentPendingPage = () => import('@/pages/PaymentPendingPage.vue');
const Contacts = () => import('@/pages/Contacts.vue');
const TextPage = () => import('@/pages/TextPage.vue');
const EmailAlreadyVerified = () => import('@/pages/EmailAlreadyVerified.vue');
const EmailVerificationNotice = () => import('@/pages/EmailVerificationNotice.vue');
const EmailVerificationSuccess = () => import('@/pages/EmailVerificationSuccess.vue');
const ResetPassword = () => import('@/pages/ResetPassword.vue');
const PageNotFound = () => import('@/pages/PageNotFound.vue');

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: Home },
  { path: '/product-list', name: 'ProductList', component: ProductList },
  {
    path: '/profile/:page',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true },
  },
  { path: '/products/:type/:id', name: 'ProductPage', component: ProductPage },
  { path: '/coin-bundles/:slug', name: 'CoinBundlePage', component: CoinBundlePage },
  { path: '/success-payment', name: 'PaymentSuccessPage', component: PaymentSuccessPage },
  { path: '/fail-payment', name: 'PaymentFaliPage', component: PaymentFaliPage },
  { path: '/processing-payment', name: 'PaymentPendingPage', component: PaymentPendingPage },
  { path: '/contacts', name: 'Contacts', component: Contacts },
  { path: '/pages/:id', name: 'TextPage', component: TextPage },
  { path: '/email/verify/already-success', name: 'EmailAlreadyVerified', component: EmailAlreadyVerified },
  { path: '/email/verify/success', name: 'EmailVerificationSuccess', component: EmailVerificationSuccess },
  { path: '/email/verify/notice', name: 'EmailVerificationNotice', component: EmailVerificationNotice },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword, props: true },
  { path: '/:pathMatch(.*)*', name: 'PageNotFound', component: PageNotFound, props: { title: 'PageNotFound' } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated') || 'false');
  const emailVerified = JSON.parse(localStorage.getItem('emailVerified') || 'false');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Для уведомлений используйте доступный вам плагин toast или свой код
      // Например, если вы используете vue-toastification:
      // import { useToast } from 'vue-toastification';
      // const toast = useToast();
      // toast.info("Please log in first");
      console.info('Please log in first'); // пока заглушка
      next({ name: 'Home', query: { redirect: to.fullPath } });
    } else if (!emailVerified) {
      console.info('Please verify your email');
      next({ name: 'EmailVerificationNotice', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
